import Materialize from 'materialize-css'

const dialog = () => ({
  toast (message, duration) {
    Materialize.toast(message, duration)
  }
})

export default dialog
